import script from "./AccountingQueue.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountingQueue.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__